export const helpArticles = {
  HELP_CENTER: 'https://cliqforms.com/help-center',
  QUICK_START_GUIDDE_EMBED: 'https://embed.app.guidde.com/playbooks/1XhjPrQ3igP8wjVcNRWpd3?mode=videoOnly',
  FEATURES_TOUR_GUIDDE_EMBED: 'https://embed.app.guidde.com/playbooks/28XS2urHFFeEcAALe5UiRp?mode=videoOnly',
  LEAD_PROOFS: 'https://cliqforms.com/leadproof/how-can-i-use-leadproof-on-my-website',
  PARTIAL_LEADS: 'https://www.cliqforms.com/help/partial-lead-submissions',
  LOGIC_JUMP: 'https://www.cliqforms.com/help/how-to-create-conditional-logic-forms',
  DEFAULT_COUNTRY_CODE: 'https://cliqforms.com/help-center',
  REPLY_TO_ADDRESS: 'https://www.cliqforms.com/help/how-does-the-reply-to-header-setting-in-email-notifications-work',
  ALLOW_BLOCK_EMAIL_DOMAINS: 'https://cliqforms.com/help-center',
  PRE_SELECTED_CHOICE: 'https://cliqforms.com/help-center',
  STEP_COUNT: 'https://cliqforms.com/help-center',
  AUTO_NAVIGATION: 'https://www.cliqforms.com/help/what-is-auto-navigation-in-multi-step-forms',
  HIDDEN_FIELDS: 'https://cliqforms.com/help-center',
  CHOICE_FORMULA: 'https://www.cliqforms.com/help/how-to-build-a-calculator-form',
  FOOTER_TEXT: 'https://cliqforms.com/help-center',
  INTEGRATIONS: 'https://www.cliqforms.com/help/what-type-of-integrations-does-cliqforms-app-support',
  UTM_PARAMETERS: 'https://www.cliqforms.com/help/how-to-capture-utm-parameters-for-accurate-campaign-tracking',
  RECAPTCHA: 'https://www.cliqforms.com/help/how-to-add-google-recaptcha-on-your-cliqforms-forms',
  ANSWER_PIPING: 'https://www.cliqforms.com/help/how-to-use-answer-piping-in-my-form',
  LANDING_PAGE_PROMPTS: 'https://www.cliqforms.com/help/landing-page-prompts',
  PAUSE_AND_CANCEL_SUBSCRIPTION: 'https://www.cliqforms.com/help/how-to-cancel-pause-or-resume-your-plan',
  PLAN_CANCELLATION: 'https://www.cliqforms.com/help/how-to-cancel-pause-or-resume-your-plan',
  URL_PARAMETERS: 'https://www.cliqforms.com/help/how-to-use-url-parameters-for-form-prefilling',
  GLOBAL_API_KEYS: 'https://www.cliqforms.com/help/how-can-i-use-google-powered-address-autocomplete-in-cliqforms-forms',
  HELP_YOUTUBE: 'https://www.youtube.com/channel/UCgzgy4jaJxN-1UbIPD9utSw?sub_confirmation=1',
  GEOLOCATION_RESTRICTIONS: 'https://www.cliqforms.com/help/how-does-the-geolocation-feature-work',
  STEPS_SUMMARY: 'https://www.cliqforms.com/help/how-can-i-add-a-summary-step-for-users-to-review-their-answers-before-submitting-the-form',
  FORM_EMBED: 'https://www.cliqforms.com/help/how-can-i-embed-cliqforms-forms-full-guide',
  TRUSTEDFORM_INTEGRATION: 'https://www.cliqforms.com/help/trustedform-integration',
  TERMS_AND_CONDITIONS: 'https://cliqforms.com/terms-and-conditions',
  PRIVACY_POLICY: 'https://cliqforms.com/privacy-policy',
  DATA_PROCESSING_AGREEMENT: 'https://cliqforms.com/data-processing-agreement',
  CONTACT_STATE_INTEGRATION: 'https://www.cliqforms.com/help/contact-state-integration-guide',
  WEBHOOK_INTEGRATION: 'https://www.cliqforms.com/help/integrations-guide-how-to-integrate-cliqforms-via-webhooks',
  SIGNATURE_AUDIT_TRAIL: 'https://www.cliqforms.com/help/how-to-use-audit-trail-in-cliqforms',
  NON_QUALIFYING_DISPLAY: 'https://cliqforms.com/help-center',
}
